import React from 'react';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import './SearchFilter.scss';

interface SearchFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({
  value,
  onChange,
  placeholder,
  className,
}) => {
  const { t } = useTranslation();
  const searchPlaceholder = placeholder || t('searchPlaceholder');
  
  return (
    <div className={`search-filter${className ? ` ${className}` : ''}`}>
      <div className="input-search-box">
        <InputText
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="input-search"
        />
      </div>
    </div>
  );
};

